$(function () {
    function sendCallback(element, token) {
        $('#submit').attr('disabled', 'disabled');

        var data = new FormData(element);
        data.append('token', token);

        window.Request.post('/callback/callback/send', Object.fromEntries(data), function(response) {
            $(element).find('.input, .textarea').removeClass('is-danger');
            if (response.hasOwnProperty('errors')) {
                var message = [];
                for (var key in response.errors) {
                    $(element).find('#callbackform-' + key.toLowerCase()).addClass('is-danger');
                    message.push(response.errors[key]);
                }
                window.Modal.show('message', {message: message.join('<br>')});
                $('#submit').removeAttr('disabled');
                return;
            }

            $(element).find('#submit').fadeOut();
            window.Modal.show('message', {message: response.message});
            window.Modal.hide($('#callback-modal'));
            if (window.ym && window.ymCounters && window.ymCounters.companyID) {
                window.ym(window.ymCounters.companyID, 'reachGoal', 'СallbackSent');
            }
        }, 'json');
    }

    $(document).on('submit', '.callback-form', function (e) {
        e.preventDefault();
        var element = this;
        getReCaptchaToken(function (token) {
            sendCallback(element, token);
        }, 'callback')
    });
});